"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconGrowthFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M2 1C1.44772 1 1 1.44772 1 2C1 4.13984 1.53414 5.87871 2.86941 6.96361C3.94338 7.83622 5.36708 8.14526 7 8.08543V14C7 14.5523 7.44772 15 8 15C8.55228 15 9 14.5523 9 14V11.0477C11.1663 11.0307 12.6764 10.2517 13.6469 9.07321C14.7234 7.76605 15 6.12965 15 5.00001C15 4.48626 14.6107 4.05609 14.0995 4.00497C11.7537 3.77039 10.0631 4.33218 8.91624 5.3437C8.79363 4.38468 8.4976 3.45088 7.79529 2.69455C6.68244 1.49609 4.80589 1 2 1Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M2 1C1.44772 1 1 1.44772 1 2C1 4.80651 1.70081 7.00371 3.36941 8.35945C4.78876 9.51267 6.72049 9.90044 9 9.76412V18C9 18.5523 9.44771 19 10 19C10.5523 19 11 18.5523 11 18V13.7285C13.9859 13.7861 16.0032 12.7597 17.2719 11.219C18.6401 9.5577 19 7.46298 19 6C19 5.48624 18.6107 5.05608 18.0995 5.00496C14.6885 4.66386 12.3951 5.61648 10.9571 7.18411C10.8539 5.70134 10.5178 4.26746 9.48279 3.15288C8.0991 1.66275 5.72256 1 2 1Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M2 1C1.44772 1 1 1.44772 1 2C1 5.47317 1.86747 8.12871 3.86941 9.75528C5.62969 11.1855 8.06676 11.6532 11 11.438V22C11 22.5523 11.4477 23 12 23C12.5523 23 13 22.5523 13 22V16.4037C16.8105 16.5393 19.3324 15.2646 20.8969 13.3649C22.5568 11.3494 23 8.7963 23 6.99999C23 6.48623 22.6107 6.05607 22.0995 6.00495C17.668 5.5618 14.8134 6.89158 13.1031 8.96844C13.0612 9.01923 13.0202 9.07036 12.9799 9.12181C12.9018 7.0667 12.55 5.09703 11.1703 3.61122C9.51577 1.82942 6.63922 1 2 1Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M2.5 1C1.67157 1 1 1.67157 1 2.5C1 7.32494 2.06794 10.9909 4.81161 13.1911C7.18766 15.0964 10.4945 15.6304 14.5 15.3261V29.5C14.5 30.3284 15.1716 31 16 31C16.8284 31 17.5 30.3284 17.5 29.5V22.2716C22.7495 22.4536 26.1844 20.802 28.2882 18.2179C30.5242 15.4715 31 11.9731 31 9.50001C31 8.72938 30.4161 8.08414 29.6493 8.00746C23.6846 7.41098 19.8178 8.98144 17.4714 11.6423C17.3735 8.95074 16.95 6.37328 15.1642 4.44042C12.9253 2.01711 8.95044 1 2.5 1Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;